import React, { useState } from 'react'
import { useScene } from '../context/SceneContext'

const SnapControls = () => {
  const { selectedObject, transformMode } = useScene()
  const [snapEnabled, setSnapEnabled] = useState(true)
  const [snapToGrid, setSnapToGrid] = useState(false)
  const [snapDistance, setSnapDistance] = useState(0.5)

  // Only show when in move mode with selected object
  if (transformMode !== 'move' || !selectedObject) {
    return null
  }

  return (
    <div className="absolute top-20 right-4 bg-white bg-opacity-95 rounded-lg p-4 shadow-lg z-10 max-w-xs">
      <h3 className="font-bold text-gray-800 mb-3">Surface Snap Settings</h3>
      
      <div className="space-y-3">
        {/* Snap Enable/Disable */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium text-gray-700">
            Surface Snapping
          </label>
          <button
            onClick={() => setSnapEnabled(!snapEnabled)}
            className={`w-12 h-6 rounded-full transition-colors ${
              snapEnabled ? 'bg-green-500' : 'bg-gray-300'
            }`}
          >
            <div className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
              snapEnabled ? 'translate-x-6' : 'translate-x-1'
            }`} />
          </button>
        </div>

        {/* Grid Snap */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium text-gray-700">
            Grid Snap
          </label>
          <button
            onClick={() => setSnapToGrid(!snapToGrid)}
            className={`w-12 h-6 rounded-full transition-colors ${
              snapToGrid ? 'bg-blue-500' : 'bg-gray-300'
            }`}
          >
            <div className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
              snapToGrid ? 'translate-x-6' : 'translate-x-1'
            }`} />
          </button>
        </div>

        {/* Snap Distance */}
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-1">
            Snap Distance: {snapDistance}
          </label>
          <input
            type="range"
            min="0.1"
            max="2.0"
            step="0.1"
            value={snapDistance}
            onChange={(e) => setSnapDistance(parseFloat(e.target.value))}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
        </div>

        {/* Visual Indicators */}
        <div className="border-t pt-3">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Visual Indicators</h4>
          <div className="space-y-1 text-xs">
            <div className="flex items-center">
              <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
              <span>Ground surface</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 bg-orange-500 rounded-full mr-2"></div>
              <span>Object surface</span>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="border-t pt-3">
          <h4 className="text-sm font-medium text-gray-700 mb-2">How to Use</h4>
          <div className="text-xs text-gray-600 space-y-1">
            <div>• Hover over surfaces to see snap preview</div>
            <div>• Click to place object on surface</div>
            <div>• Objects automatically align to surface normal</div>
            <div>• Hold Shift to disable snapping temporarily</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SnapControls
